// AUTO-GENERATED by scripts/generate-abis.mjs from solidity/interfaces/*.sol.
// Run `bun run generate:abis` after adding, renaming, or removing an interface.
// Do not edit by hand — your changes will be overwritten.

import { sol, solFile } from 'soltag'

export const BlueBuyCallbackAbi = sol('IBlueBuyCallback')`
  ${solFile('../solidity/interfaces/IBlueBuyCallback.sol', { raw: true })}
`.abi

export const BlueBuyCallbackFactoryAbi = sol('IBlueBuyCallbackFactory')`
  ${solFile('../solidity/interfaces/IBlueBuyCallbackFactory.sol', { raw: true })}
`.abi

export const BluePublicAllocatorAbi = sol('IBluePublicAllocator')`
  ${solFile('../solidity/interfaces/IBluePublicAllocator.sol', { raw: true })}
`.abi

export const EcrecoverRatifierAbi = sol('IEcrecoverRatifier')`
  ${solFile('../solidity/interfaces/IEcrecoverRatifier.sol', { raw: true })}
`.abi

export const MetaMorphoAbi = sol('IMetaMorpho')`
  ${solFile('../solidity/interfaces/IMetaMorpho.sol', { raw: true })}
`.abi

export const MetaMorphoFactoryAbi = sol('IMetaMorphoFactory')`
  ${solFile('../solidity/interfaces/IMetaMorphoFactory.sol', { raw: true })}
`.abi

export const MetaMorpho_v1_1Abi = sol('IMetaMorpho_v1_1')`
  ${solFile('../solidity/interfaces/IMetaMorpho_v1_1.sol', { raw: true })}
`.abi

export const MidnightAbi = sol('IMidnight')`
  ${solFile('../solidity/interfaces/IMidnight.sol', { raw: true })}
`.abi

export const MidnightBundlesAbi = sol('IMidnightBundles')`
  ${solFile('../solidity/interfaces/IMidnightBundles.sol', { raw: true })}
`.abi

export const MidnightBundlesV2Abi = sol('IMidnightBundlesV2')`
  ${solFile('../solidity/interfaces/IMidnightBundlesV2.sol', { raw: true })}
`.abi

export const MorphoBlueAbi = sol('IMorphoBlue')`
  ${solFile('../solidity/interfaces/IMorphoBlue.sol', { raw: true })}
`.abi

export const MorphoMarketV1AdapterAbi = sol('IMorphoMarketV1Adapter')`
  ${solFile('../solidity/interfaces/IMorphoMarketV1Adapter.sol', { raw: true })}
`.abi

export const MorphoMarketV1AdapterFactoryAbi = sol('IMorphoMarketV1AdapterFactory')`
  ${solFile('../solidity/interfaces/IMorphoMarketV1AdapterFactory.sol', { raw: true })}
`.abi

export const MorphoMarketV1AdapterV2Abi = sol('IMorphoMarketV1AdapterV2')`
  ${solFile('../solidity/interfaces/IMorphoMarketV1AdapterV2.sol', { raw: true })}
`.abi

export const MorphoMarketV1AdapterV2FactoryAbi = sol('IMorphoMarketV1AdapterV2Factory')`
  ${solFile('../solidity/interfaces/IMorphoMarketV1AdapterV2Factory.sol', { raw: true })}
`.abi

export const MorphoVaultV1AdapterAbi = sol('IMorphoVaultV1Adapter')`
  ${solFile('../solidity/interfaces/IMorphoVaultV1Adapter.sol', { raw: true })}
`.abi

export const MorphoVaultV1AdapterFactoryAbi = sol('IMorphoVaultV1AdapterFactory')`
  ${solFile('../solidity/interfaces/IMorphoVaultV1AdapterFactory.sol', { raw: true })}
`.abi

export const OracleAbi = sol('IOracle')`
  ${solFile('../solidity/interfaces/IOracle.sol', { raw: true })}
`.abi

export const PriceRatifierV1Abi = sol('IPriceRatifierV1')`
  ${solFile('../solidity/interfaces/IPriceRatifierV1.sol', { raw: true })}
`.abi

export const PublicAllocatorAbi = sol('IPublicAllocator')`
  ${solFile('../solidity/interfaces/IPublicAllocator.sol', { raw: true })}
`.abi

export const RateRatifierV1Abi = sol('IRateRatifierV1')`
  ${solFile('../solidity/interfaces/IRateRatifierV1.sol', { raw: true })}
`.abi

export const SafeWalletAbi = sol('ISafeWallet')`
  ${solFile('../solidity/interfaces/ISafeWallet.sol', { raw: true })}
`.abi

export const SetterRatifierAbi = sol('ISetterRatifier')`
  ${solFile('../solidity/interfaces/ISetterRatifier.sol', { raw: true })}
`.abi

export const VaultAbi = sol('IVault')`
  ${solFile('../solidity/interfaces/IVault.sol', { raw: true })}
`.abi

export const VaultFactoryAbi = sol('IVaultFactory')`
  ${solFile('../solidity/interfaces/IVaultFactory.sol', { raw: true })}
`.abi
